import { useSelector } from "react-redux";
import companySelectors from "store/selectors/company";
import { formatFlagsAsTimelineItems, type TimelineItem } from "./helpers";

export interface CompanyRiskStatusHook {
  cid?: string;
  timelineItems: TimelineItem[];
}

export default function useCompanyRiskStatus(): CompanyRiskStatusHook {
  const id = useSelector(companySelectors.getId);
  const monitor = useSelector(companySelectors.getCompanyMonitor);
  const timelineItems = formatFlagsAsTimelineItems(monitor?.flags || []);

  return {
    cid: id,
    timelineItems,
  };
}
